import splitBreakpoints from '../split-breakpoints'

const alignMap = {
  start: 'flex-start',
  end: 'flex-end'
}

const justifyMap = {
  start: 'flex-start',
  end: 'flex-end'
}

function parseAlignment ({ justify, align }) {

  return {
    justifyContent: justifyMap[justify] || justify,
    alignItems: alignMap[align] || align
  }  
}

export default splitBreakpoints(parseAlignment)
